import React from 'react';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { IWithWorksheetInjectedProps, WorksheetGridFieldSection, WorksheetRecordGrid } from '../../../../Core';
import { Field, NumericInput, Checkbox } from '../../../../../Core';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/Aashto/gridFieldSets';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';

let LiquidLimitMethodATrialSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t, i) => ({
        dim: t.ExcludedTrial,
        preventRemove: i < 3,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="Trials">
      <WorksheetRecordGrid
        name={'Trials'}
        orientation={'horizontal'}
        recordProps={{
          width: 130,
          preventRemove: (i) => trialRecordProps[i]?.preventRemove,
          dim: (i) => trialRecordProps[i]?.dim,
          enforceAtLeastOneRecord: true,
          removeConfirm: {
            confirm: true,
            confirmTitle: 'Trial Deletion',
            confirmText: 'Are you sure you want to delete the selected trial?',
            confirmButtonText: 'Delete Trial',
          },
        }}
        fieldSet={[
          {
            name: 'Drops',
            component: <Field input={<NumericInput />} />,
            label: 'Drops', // Remove when labels migrated to config
          },
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
          {
            name: 'ExcludedTrial',
            component: <Field input={<Checkbox />} />,
            label: 'Exclude Trial', // Remove when labels migrated to config
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

LiquidLimitMethodATrialSection = withInjectedProps(LiquidLimitMethodATrialSection);

export { LiquidLimitMethodATrialSection };
export default LiquidLimitMethodATrialSection;
